<!--
 * @Description: 新增和详情审批代理模块
 * @Autor: lwq
 * @Date: 2020-07-29 11:17:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-08 10:52:01
 * @FilePath: \mrc-base-server-view\src\views\approver\modules\approverInfo.vue
-->
<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <mrc_ess_staffInfo v-model="params.agent_staff_uuid"
                               :multiple="false"
                               itemValue="user_id"
                               :readonly="disabled"
                               :dropDownList="agent_staff_uuid_arr"
                               :error-messages="
                $errors('params', 'agent_staff_uuid', requiredRule)
              "
                               :label="$t('label_The_acting_employee') + '*'"></mrc_ess_staffInfo>
          </v-col>
          <v-col cols="12">
            <mrc_ess_staffInfo v-model="params.proxy_staff_uuid"
                               :multiple="false"
                               itemValue="user_id"
                               :readonly="disabled"
                               :dropDownList="proxy_staff_uuid_arr"
                               :error-messages="
                $errors('params', 'proxy_staff_uuid', requiredRule)
              "
                               :label="$t('label_Acting_employee') + '*'">
            </mrc_ess_staffInfo>
          </v-col>
          <v-col cols="12">
            <mrc_ess_prompt :rules="false"
                            :errMsg="$errors('params', 'flow_proxy_type_uuid', requiredRule)"
                            v-model="params.flow_proxy_type_uuid"
                            :label="$t('label_The_type_of_business') + '*'"
                            :disabled="disabled"
                            :obj="agent_approval_type">
            </mrc_ess_prompt>
          </v-col>
          <v-col cols="12">
            <v-row class="d-flex">
              <v-col>
                <mrc_ess_datePicker :label="$t('label_Start_date') + '*'"
                                    :disabled="disabled"
                                    :errMsg="
                    $errors(
                      'params',
                      'effective_start',
                      requiredRule.concat([
                        {
                          rule: 'beforeDate',
                          msg: $t('verify_cannot_exceed_the_expiration_date'),
                        },
                      ])
                    )
                  "
                                    v-model="params.effective_start"></mrc_ess_datePicker>
              </v-col>
              <!-- <div class="d-flex align-center"><span style="font-size: 22px;color: #383838;">></span></div> -->
              <div class="d-flex"
                   style="font-size:28px;align-items:center">
                <v-icon class="material-icons">arrow_forward_ios</v-icon>
              </div>
              <v-col>
                <mrc_ess_datePicker :label="$t('label_End_date') + '*'"
                                    :disabled="disabled"
                                    :errMsg="
                    $errors(
                      'params',
                      'effective_end',
                      requiredRule.concat([
                        {
                          rule: 'afterDate',
                          msg: $t('verify_no_later_than_the_start_time'),
                        },
                      ])
                    )
                  "
                                    v-model="params.effective_end"></mrc_ess_datePicker>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12"
                 class="d-flex">
            <div class="mr-3">
              <v-checkbox v-model="params.is_forward_all_incompleted_items_now"
                          style="white-space: nowrap;"
                          :true-value="1"
                          :readonly="disabled"
                          :label="$t('label_Forward_unapproved_items_to_delegates')"
                          :false-value="0"></v-checkbox>
            </div>
            <div>
              <v-checkbox v-model="params.is_return_all_incompleted_items_whenexpired"
                          :true-value="1"
                          style="white-space: nowrap;"
                          :readonly="disabled"
                          :label="$t('label_After_the_agent_ends')"
                          :false-value="0"></v-checkbox>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn @success="success"
                         v-if="!disabled"
                         @cancel="cancel"></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import { getStaffListForFilter } from "@/service/api/autoComplete.js"
import {
  updateApprover,
  detailApprover,
  addApprover,
} from "@/service/api/approver"
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      skeletonloading: true,
      params: {
        flow_proxy_type_uuid: "",
        effective_start: "",
        effective_end: "",
        agent_staff_uuid: "",
        proxy_staff_uuid: "",
        is_forward_all_incompleted_items_now: 0,
        is_return_all_incompleted_items_whenexpired: 0,
      },
      agent_staff_uuid_arr: [],
      proxy_staff_uuid_arr: [],
    }
  },
  validations: {
    params: {
      agent_staff_uuid: {
        required,
      },
      proxy_staff_uuid: {
        required,
      },
      flow_proxy_type_uuid: {
        required,
      },
      effective_start: {
        required,
        beforeDate (value) {
          if (!this.params.effective_end) return true
          const prevData = new Date(value).valueOf()
          const nextData = new Date(this.params.effective_end).valueOf()
          return prevData < nextData
        },
      },
      effective_end: {
        required,
        afterDate (value) {
          if (!this.params.effective_start) return true
          const nextData = new Date(value).valueOf()
          const prevData = new Date(this.params.effective_start).valueOf()
          return prevData < nextData
        },
      },
    },
  },
  computed: {
    agent_approval_type () {
      return {
        prompt_name: "agent_approval_type",
        org_level_uuid: this.$store.state.userData.org_level_uuid,
      }
    },
  },
  created () { },
  watch: {
    async "params.agent_staff_uuid" (val) {
      await this.getStaffList(
        val,
        "proxy_staff_uuid_arr",
        this.params.proxy_staff_uuid
      )
    },
    async "params.proxy_staff_uuid" (val) {
      await this.getStaffList(
        val,
        "agent_staff_uuid_arr",
        this.params.agent_staff_uuid
      )
    },
    disabled: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_approval_agent'
          this.$store.commit('set_page_title', 'label_edit_approval_agent')
        }
        else {
          this.$route.meta.title = 'label_view_approval_agent'
          this.$store.commit('set_page_title', 'label_view_approval_agent')
        }
      }, immediate: true
    }
  },
  async mounted () {
    this.national("mrbase_sys_flow_proxy_approval")
    if (this.$store.state.uuid) {
      await this.getDetail()
    }

    await this.getStaffList(
      this.params.proxy_staff_uuid,
      "agent_staff_uuid_arr",
      this.params.agent_staff_uuid
    )
    await this.getStaffList(
      this.params.agent_staff_uuid,
      "proxy_staff_uuid_arr",
      this.params.proxy_staff_uuid
    )
  },
  methods: {
    async getStaffList (notfilter, attr, value) {
      const res = await getStaffListForFilter({
        value,
        filter: "1,2,3,5",
        org_level_uuid: this.$store.state.currentCompany,
        notfilter: notfilter,
      })
      if (res.code == 200) {
        if (Array.isArray(res.data) && res.data.length > 0) {
          this[attr] = res.data.concat([])
        } else {
          this[attr] = []
        }
      }
    },
    async getDetail () {
      this.skeletonloading = true
      const res = await detailApprover({ uuid: this.$store.state.uuid })
      if (res.code == 200) {
        this.params = res.data
      }
      this.skeletonloading = false
    },
    async success () {
      this.$v.params.$touch()
      if (this.$v.params.$error) return
      this.params.effective_start = this.$moment(this.params.effective_start)
      this.params.effective_end = this.$moment(this.params.effective_end)
      if (this.$store.state.uuid) {
        const res = await updateApprover({
          ...this.params,
          org_level_uuid: this.$store.state.currentCompany,
        })
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          })
          // this.$router.push({ name: 'approver' })
          this.$emit("changeReadonly")
          await this.getDetail()
        }
      } else {
        const res = await addApprover({
          ...this.params,
          org_level_uuid: this.$store.state.currentCompany,
        })
        if (res.code == 200) {
          this.$Message({ text: this.$t("message_added_successfully") })
          this.$router.push({ name: "approver" })
        }
      }
    },
    async cancel () {
      if (this.$store.state.uuid) {
        this.$emit("changeReadonly")
        await this.getDetail()
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then(() => {
            this.$router.go(-1)
          })
          .catch(() => { })
      }
    },
  },
}
</script>

<style scoped></style>
